import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import MaskedInput from 'react-text-mask';

import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { MaskCel } from "beaktShared/helpers/masks";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function ProfissionalForm({ addItem, deleteItem, item, handleView, loading }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);

    const { register, handleSubmit, setValue, setError, errors, clearError } = useForm({ mode: "onBlur" });

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    
    const showNotification = (mensagem,color) => { 
          setMensagemNotification(mensagem);
          setColorNotification(color);      
          setNotification(true);
          setTimeout(function() {
              setNotification(false);
          }, 6000);       
    };

    const [disable, setDisable] = React.useState(false);

    const [agendaCheckbox, setAgendaCheckbox] = React.useState(false);

    const intialValues = {
        id: 0,
        nome: '',
        ativo: true,
        celular: '',
        pathFoto: '',
        possuiAgenda: false,
        profissionalEspecialidades: [],
        usuarioId: 0,
        email: ''
    };
   
    const [loadingValidateEmail, setloadingValidateEmail] = React.useState(false);
    const handleEmailChange = e => {
        let email = e.target.value;
        if (email === "")
            return;
        
        setloadingValidateEmail(true);
        const endPoint = "profissionais/vefifyemail/" + email + "/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status === 200) 
            {
                LoadDadosItem(result.data);
                showNotification("Profissional já cadastrado!",'info');
                
                setDisable(true);
                if (session.tipoPerfil === 0 || 
                    session.tipoPerfil === 1 || 
                    session.tipoPerfil === 4)
                    setDisable(false);

                setloadingValidateEmail(false);
                return true;
            }
            else
            {
                if (item === undefined || item === null)
                    ClearDados();
                setDisable(true);
                if (session.tipoPerfil === 0 || 
                    session.tipoPerfil === 1 || 
                    session.tipoPerfil === 4)
                    setDisable(false);
                setloadingValidateEmail(false);
            }
        });
    };

    const [expediente, setExpediente] = React.useState("");
    const [listSelectExpediente, setListSelectExpediente] = React.useState([]);

    const [especialidade, setEspecialidade] = React.useState([]);
    const [listSelectEspecialidade, setListSelectEspecialidade] = React.useState([]);

    const [servico, setservico] = React.useState([]);
    const [listSelectServicoall, setlistSelectServicoall] = React.useState([]);
    const [listSelectServico, setlistSelectServico] = React.useState([]);

    const handleExpedienteChange = event => {
        setExpediente(event.target.value);
        setValue("expediente", event.target.value);
        if (event.target.value !== "")
            clearError("expediente");
    };

    const handleEspecialidadeChange = event => {
        setEspecialidade(event.target.value);
        setValue("especialidade", event.target.value);
        if (event.target.value !== "")
            clearError("especialidade");

        // FilterServicosByEspecialidadeSelected(event.target.value);
    };

    const handleServicoChange = event => {
        setservico(event.target.value);
        setValue("servico", event.target.value);
        if (event.target.value !== "")
            clearError("servico");
    };

    const [loadDadosItem, setloadDadosItem] = React.useState(false);
    useEffect(() => {
        LoadSelectEspecialidades();
        LoadSelectServicos();
        LoadSelectExpedientes();
        sendScrollToTOP();
    }, []);

    const LoadSelectEspecialidades = () => {
        const endPoint = "especialidades/ativos/byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');
                return false;
            }
            setListSelectEspecialidade(result.data);
            return true;
        });
    }

    const LoadSelectServicos = () => {
        const endPoint = "servicos/ativos/byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');
                return false;
            }
            setlistSelectServicoall(result.data);
            setlistSelectServico(result.data);     
            setloadDadosItem(true)
            return true;
        });
    }

    const LoadSelectExpedientes = () => {
        const endPoint = "expedientes/ativos/byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');
                return false;
            }
            setListSelectExpediente(result.data);
            return true;
        });
    };

    useEffect(() => {
        setDisable(true);
        if (session.tipoPerfil === 0 || 
            session.tipoPerfil === 1 || 
            session.tipoPerfil === 4)
            setDisable(false);
        if (loadDadosItem)
            LoadDadosItem(item);
        sendScrollToTOP();
    }, [item, loadDadosItem]);

    const LoadDadosItem = (item) => {
       if (!item.profissionalId)
            return;
        
        setValue('id', item.profissionalId);
        setValue('usuarioId', item.usuarioId);
        setValue('nome', item.nome);
        setValue('celular', item.celular);

        if(item.estabelecimentoProfissionais.length > 0)
            setAgendaCheckbox(item.estabelecimentoProfissionais[0].possuiAgenda);
        else
            setAgendaCheckbox(0);

        if (item.profissionalExpedientes) {
            if (item.profissionalExpedientes[0]) {
                setExpediente(item.profissionalExpedientes[0].expedienteId);
                setValue("expediente", item.profissionalExpedientes[0].expedienteId);
            }
        }
        let arrayEspecialidade = readArrayPE(item.profissionalEspecialidades);
        setEspecialidade(arrayEspecialidade);
        setValue("especialidade", arrayEspecialidade);
        let arrayServico = readArrayPS(item.profissionalServicos);
        setservico(arrayServico);
        setValue("servico", arrayServico);
        setValue("email", item.email);

        // FilterServicosByEspecialidadeSelected(arrayEspecialidade);
    };

    const readArrayPE = (especialidades) => {
        let array = [];
        for (var i = 0; i < especialidades.length; i++)
            array.push(especialidades[i].especialidadeId);
        return array;
    };

    const readArrayPS = (servicos) => {
        let array = [];
        for (var i = 0; i < servicos.length; i++)
            array.push(servicos[i].servicoId);
        return array;
    };

    const onSubmit = (data, e) => {
        e.preventDefault();
        addItem({
            profissionalId: parseInt(data.id),
            nome: data.nome,
            ativo: true,
            celular: data.celular,
            profissionalEspecialidades: createListPE(parseInt(data.id), data.especialidade),
            profissionalServicos: createListPS(parseInt(data.id), data.servico),
            usuarioCadastroId: session.id,
            email: data.email,
            usuarioId: parseInt(data.usuarioId),
            profissionalExpedientes: [{
                profissionalId: parseInt(data.id),
                estabelecimentoId: session.estabelecimentoId,
                expedienteId: data.expediente
            }],
            estabelecimentoProfissionais : [{
                estabelecimentoId: session.estabelecimentoId,
                profissionalId: parseInt(data.id),
                possuiAgenda: agendaCheckbox
            }]
        });
    };

    const createListPE = (id, especialidades) => {
        let listPE = [];
        for (var i = 0; i < especialidades.length; i++)
            listPE.push({ profissionalId: id, estabelecimentoId: session.estabelecimentoId, especialidadeId: especialidades[i] });
        return listPE;
    };

    const createListPS = (id, servicos) => {

        var servicoSelecionadosCom = listSelectServicoall.filter(({ servicoId }) => servicos.indexOf(servicoId) != -1);
        // var servicosbyEspecialidade = servicoSelecionadosCom.filter(({ especialidadeId }) => especialidade.indexOf(especialidadeId) != -1);

        let listPS = [];
        for (var i = 0; i < servicoSelecionadosCom.length; i++) {
            listPS.push({ profissionalId: id, estabelecimentoId: session.estabelecimentoId, servicoId: servicoSelecionadosCom[i].servicoId });
        }
        return listPS;
    };

    const handleViewForm = () => {
        handleView();
    };

    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();
    const showAlertDelete = id => {
        setAlertDelete({
            statusAlert: 1,
            idToDeleteRecieve: id
        });
    };
    useEffect(() => {
        if (alertDelete.isToDelete)
            deleteItem(alertDelete.idToDeleteSend);
        sendScrollToTOP();
    }, [alertDelete]);

    const inputLabel = React.useRef(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
        sendScrollToTOP();
    }, []);

    const ClearDados = () => {
        setValue('id', 0);
        setValue('usuarioId', 0);
        setValue('nome', '');
        setValue('celular', '');
        setAgendaCheckbox(false);
        setExpediente([]);
        setEspecialidade([]);
        setservico([]);
    };

    const sendScrollToTOP = () => {
        const container = document.querySelector('#divscroll');
        container.scrollTop = 0;
        container.behavior = 'smooth';
    };

    return (
        <div className="maxContent">
            <form onSubmit={handleSubmit(onSubmit)}>
            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
                />
                <GridContainer className={classes.marginTopCard}>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PermIdentity />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('information_message.professional_registration')} - <small>{t('information_message.fill_in_your_details')}</small>
                                    <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                                    <input className={classes.hidden} defaultValue={intialValues.usuarioId} name="usuarioId" ref={register} />
                                </h4>
                            </CardHeader>
                            <CardBody className={classes.cardMargin}>

                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                disabled={disable && item.profissionalId != null}
                                                error={errors.email ? true : false}
                                                label={t('label.email') + " *"}
                                                variant="outlined"
                                                //onChange={handleEmailChange}
                                                onBlur={handleEmailChange}
                                                inputRef={register({
                                                    required: t('label.required'),
                                                    pattern: {
                                                        value: /^\S+@\S+$/i,
                                                        message: t('label.invalid_email')
                                                    },
                                                    maxLength: {
                                                        value: 50,
                                                        message: t('label.enter_a_maximum_of_50_characters')
                                                    },
                                                })}
                                                name="email"
                                                defaultValue={intialValues.email}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {loadingValidateEmail && <LoadingIcon className="rotate" />}
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            {errors.email && <FormHelperText className={classes.labelRootError}>
                                                <span> {errors.email.message} </span>
                                            </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                disabled={disable}
                                                error={errors.nome ? true : false}
                                                label={t('label.name') + " *"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="nome"
                                                defaultValue={intialValues.nome}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ maxLength: 150 }}
                                            />
                                            {errors.nome && <FormHelperText className={classes.labelRootError}>
                                                <span>{t('label.required')}</span>
                                            </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                disabled={disable}
                                                error={errors.celular ? true : false}
                                                label={t('label.cell_phone')}
                                                variant="outlined"
                                                inputRef={register({ required: false })}
                                                name="celular"
                                                defaultValue={intialValues.celular}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputComponent: MaskCel,
                                                }}
                                            />
                                            {errors.celular && <FormHelperText className={classes.labelRootError}>
                                                <span> {t('error_message.undefined_error')} </span>
                                            </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.expediente ? true : false}
                                                select
                                                variant="outlined"
                                                label={t('label.expedient')}
                                                value={expediente}
                                                onChange={handleExpedienteChange}
                                                name="expediente"
                                                ref={() =>
                                                    register(
                                                        { name: "expediente" },
                                                        { required: true }
                                                    )
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            >
                                                <MenuItem value="">
                                                    <em>Nenhum</em>
                                                </MenuItem>
                                                {listSelectExpediente.map(item => (
                                                    <MenuItem key={item.expedienteId}
                                                        classes={{
                                                            root: classes.selectMenuItem,
                                                            selected: classes.selectMenuItemSelected
                                                        }}
                                                        value={item.expedienteId}
                                                    >
                                                        {item.descricao}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                            {errors.expediente && <FormHelperText className={classes.labelRootError}>
                                                <span>{t('label.required')}</span>
                                            </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    // disabled={disable}
                                                    tabIndex={-1}
                                                    checked={agendaCheckbox}
                                                    onClick={event => { setAgendaCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label={t('label.has_agenda') + "?"}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <InputLabel
                                                className={classes.selectLabel + " " + classes.customLabelSelect}
                                                ref={inputLabel} htmlFor="outlined-especialidade"
                                                shrink={true}
                                            >
                                                {t('label.specialty') + " *"}
                                            </InputLabel>
                                            <Select
                                                error={errors.especialidade ? true : false}
                                                multiple
                                                input={<OutlinedInput labelWidth={labelWidth} id="outlined-especialidade" />}
                                                label="Especialidades(s) *"
                                                value={especialidade}
                                                onChange={handleEspecialidadeChange}
                                                name="especialidade"
                                                ref={() =>
                                                    register(
                                                        { name: "especialidade" },
                                                        { required: true }
                                                    )
                                                }
                                            >
                                                <MenuItem disabled>
                                                    {t('label.choose_specialties')}
                                                </MenuItem>
                                                {listSelectEspecialidade.map(item => (
                                                    <MenuItem key={item.especialidadeId}
                                                        classes={{
                                                            root: classes.selectMenuItem,
                                                            selected: classes.selectMenuItemSelectedMultiple
                                                        }}
                                                        value={item.especialidadeId}
                                                    >
                                                        {item.descricao}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {errors.especialidade && <FormHelperText className={classes.labelRootError}>
                                                <span>{t('label.required')}</span>
                                            </FormHelperText>}
                                        </FormControl>
                                    </GridItem>

                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <InputLabel
                                                className={classes.selectLabel + " " + classes.customLabelSelect}
                                                ref={inputLabel} htmlFor="outlined-servico"
                                                shrink={true}
                                            >
                                                {t('label.service') + " *"}
                                            </InputLabel>
                                            <Select
                                                error={errors.servico ? true : false}
                                                multiple
                                                input={<OutlinedInput labelWidth={labelWidth} id="outlined-servico" />}
                                                label="Servico(s) *"
                                                value={servico}
                                                onChange={handleServicoChange}
                                                name="servico"
                                                ref={() =>
                                                    register(
                                                        { name: "servico" },
                                                        { required: true }
                                                    )
                                                }
                                            >
                                                <MenuItem disabled>
                                                    {t('label.choose_services')}
                                                </MenuItem>
                                                {listSelectServico.map(item => (
                                                    <MenuItem key={item.servicoId}
                                                        classes={{
                                                            root: classes.selectMenuItem,
                                                            selected: classes.selectMenuItemSelectedMultiple
                                                        }}
                                                        value={item.servicoId}
                                                    >
                                                        {item.descricao}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {errors.servico && <FormHelperText className={classes.labelRootError}>
                                                <span> {t('label.required')} </span>
                                            </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                {item.profissionalId != null &&
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <Button onClick={() => showAlertDelete(item.profissionalId)}
                                                color="danger"                                                     
                                                simple
                                                style={{padding:"0"}}>
                                                <Close />
                                                {" "} Remover Profissional do Estabelecimento
                                            </Button>
                                        </GridItem>
                                    </GridContainer>
                                }
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>

                        <div className={classes.textCenter}>
                            <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')}
                                {loading && <div> ... {t('label.loading')}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
            {alertDelete.componente}
        </div>
    );
}
